// src/pages/user/MyRentals.jsx
import React, { useState } from "react";
import { Row, Col,  Form, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import {
  FaEllipsisV, FaExclamationCircle, FaEye, FaStar
} from "react-icons/fa";
import {
  FiX, FiHash, FiCalendar, FiUser, FiMapPin,
  FiDollarSign, FiAlertCircle, FiEye as FiEyeIcon,
  FiEdit, FiSave, FiCheckCircle
} from "react-icons/fi";
import {
  MdShoppingCart, MdCheckCircle, MdPending, MdAttachMoney
} from "react-icons/md";
import AppPagination from "../../../components/general/pagination/Pagination.js";
import UserMasterLayout from "../../../layout/useradmin/UserMasterLayout";
import "../../../assets/css/useradmin/myrentals/MyRentals.css";

const MyRentals = () => {
  const navigate = useNavigate();

  const [rentals, setRentals] = useState([
  {
    id: 1,
    renterName: "Ahmad Ali",
    equipment:  "John Deere 5075E Tractor",
    owner:      "Green Valley Farm Rentals",
    location:   "Faisalabad",
    startDate:  "2026-01-05",
    endDate:    "2026-01-05",
    totalCost:  2800,
    status:     "Active",
  },
  {
    id: 2,
    renterName: "Fatima Noor",
    equipment:  "Case IH Axial Flow Harvester",
    owner:      "Green Valley Farm Rentals",
    location:   "Lahore",
    startDate:  "2026-01-08",
    endDate:    "2026-01-08",
    totalCost:  7500,
    status:     "Completed",
  },
  {
    id: 3,
    renterName: "Hassan Raza",
    equipment:  "Massey Ferguson 240 Tractor",
    owner:      "Punjab Farm Equipment Co",
    location:   "Gujranwala",
    startDate:  "2026-01-10",
    endDate:    "2026-01-10",
    totalCost:  1400,
    status:     "Pending",
  },
  {
    id: 4,
    renterName: "Sara Ahmed",
    equipment:  "Wheat Thresher",
    owner:      "Punjab Farm Equipment Co",
    location:   "Multan",
    startDate:  "2026-01-12",
    endDate:    "2026-01-12",
    totalCost:  1600,
    status:     "Active",
  },
  {
    id: 5,
    renterName: "Ali Hassan",
    equipment:  "New Holland TD5.110 Tractor",
    owner:      "Ahmed Tractors & Machinery",
    location:   "Multan",
    startDate:  "2026-01-15",
    endDate:    "2026-01-15",
    totalCost:  3200,
    status:     "Active",
  },
  {
    id: 6,
    renterName: "Ayesha Malik",
    equipment:  "Baler NH BR6090",
    owner:      "Ahmed Tractors & Machinery",
    location:   "Islamabad",
    startDate:  "2026-01-18",
    endDate:    "2026-01-18",
    totalCost:  3000,
    status:     "Completed",
  },
  {
    id: 7,
    renterName: "Usman Khan",
    equipment:  "Laser Land Leveler",
    owner:      "Sardar Farm Equipment",
    location:   "Gujranwala",
    startDate:  "2026-01-20",
    endDate:    "2026-01-20",
    totalCost:  2200,
    status:     "Pending",
  },
]);
  // ── Pagination ──
  const [currentPage,   setCurrentPage]   = useState(1);
  const rentalsPerPage = 5;
  const totalPages     = Math.ceil(rentals.length / rentalsPerPage);
  const currentRentals = rentals.slice((currentPage - 1) * rentalsPerPage, currentPage * rentalsPerPage);

  // ── Modal states ──
  const [showDisputeModal, setShowDisputeModal] = useState(false);
  const [showDetailsModal, setShowDetailsModal] = useState(false);
  const [showReviewModal,  setShowReviewModal]  = useState(false);
  const [selectedRental,   setSelectedRental]   = useState(null);

  // ── Dropdown ──
  const [activeDropdown, setActiveDropdown] = useState(null);

  // ── Edit Mode ──
  const [isEditMode,   setIsEditMode]   = useState(false);
  const [editedRental, setEditedRental] = useState(null);

  // ── Dispute ──
  const [disputeTickets, setDisputeTickets] = useState([]);
  const [selectedTicket, setSelectedTicket] = useState(null);
  const [chatMessages,   setChatMessages]   = useState({});
  const [currentMessage, setCurrentMessage] = useState('');

  // ── Review ──
  const [rating,     setRating]     = useState(0);
  const [reviewText, setReviewText] = useState('');

  // ── Stats ──
  const statsData = [
    { icon: <MdShoppingCart />, value: rentals.length,                                       label: "Total Rentals",     iconBg: '#FFF8E6', iconColor: '#FDB714' },
    { icon: <MdShoppingCart />, value: rentals.filter(r => r.status === "Active").length,    label: "Active Rentals",    iconBg: '#FFF8E6', iconColor: '#FDB714' },
    { icon: <MdCheckCircle  />, value: rentals.filter(r => r.status === "Completed").length, label: "Completed Rentals", iconBg: '#FFF8E6', iconColor: '#FDB714' },
    { icon: <MdPending      />, value: rentals.filter(r => r.status === "Pending").length,   label: "Pending Payments",  iconBg: '#FFF8E6', iconColor: '#FDB714' },
  ];

  // ── Helpers ──
  const getStatusClass = (status) => {
    if (status === "Active")    return "mr-badge-active";
    if (status === "Completed") return "mr-badge-completed";
    return "mr-badge-pending";
  };

  const getModalStatusClass = (status) => {
    if (status === "Active")    return "mr-modal-badge-active";
    if (status === "Completed") return "mr-modal-badge-completed";
    return "mr-modal-badge-pending";
  };

  const fmtDuration = (start, end) => {
    const s = new Date(start), e = new Date(end);
    return Math.ceil((e - s) / (1000 * 60 * 60 * 24)) + 1 + " day(s)";
  };

  // ── Handlers ──
  const openDispute = (r) => { setSelectedRental(r); setShowDisputeModal(true); setActiveDropdown(null); };
  const openDetails = (r) => { setSelectedRental(r); setEditedRental({...r}); setIsEditMode(false); setShowDetailsModal(true); setActiveDropdown(null); };
  const openReview  = (r) => { setSelectedRental(r); setRating(0); setReviewText(''); setShowReviewModal(true); setActiveDropdown(null); };

  const handleEditChange = (field, value) => setEditedRental({ ...editedRental, [field]: value });

  const handleSaveEdit = () => {
    setRentals(rentals.map(r => r.id === editedRental.id ? editedRental : r));
    setSelectedRental(editedRental);
    setIsEditMode(false);
    alert('Rental details updated!');
  };

  const handleDisputeSubmit = (e) => {
    e.preventDefault();
    const fd = new FormData(e.target);
    const ticket = {
      id: Date.now(), raisedBy: fd.get('raisedBy'), against: fd.get('against'),
      category: fd.get('category'), date: fd.get('date'), description: fd.get('description'),
      equipment: selectedRental?.equipment || 'N/A', status: 'Open', createdAt: new Date().toLocaleString()
    };
    setDisputeTickets([...disputeTickets, ticket]);
    setChatMessages({ ...chatMessages, [ticket.id]: [] });
    setSelectedTicket(ticket);
    e.target.reset();
    alert('Dispute ticket submitted!');
  };

  const handleSendMessage = () => {
    if (!currentMessage.trim() || !selectedTicket) return;
    const msg = { id: Date.now(), sender: 'User', message: currentMessage, timestamp: new Date().toLocaleTimeString() };
    setChatMessages({ ...chatMessages, [selectedTicket.id]: [...(chatMessages[selectedTicket.id] || []), msg] });
    setCurrentMessage('');
  };

  const handleReviewSubmit = (e) => {
    e.preventDefault();
    if (rating === 0) { alert('Please select a rating!'); return; }
    alert('Thank you for your review!');
    setShowReviewModal(false);
  };

  // ── Outside click to close dropdown ──
  React.useEffect(() => {
    const close = (e) => { if (!e.target.closest('.mr-dropdown-wrapper')) setActiveDropdown(null); };
    document.addEventListener('click', close);
    return () => document.removeEventListener('click', close);
  }, []);

  // ================================================================
  // RETURN
  // ================================================================
  return (
    <UserMasterLayout>
      <div className="mr-page">

        {/* ── Header ── */}
        <div className="mr-page-header">
          <h2 className="mr-page-title">My Rentals</h2>
          <button className="mr-request-btn" onClick={() => navigate("/rent")}>
            + Rental Request
          </button>
        </div>

        {/* ── Stat Cards — same as UserDashboard / RentalRequest ── */}
        <div className="mr-stats-container">
          <Row className="g-4 mb-4">
            {statsData.map((s, i) => (
              <Col key={i} xl={3} lg={3} md={6} sm={12}>
                <div className="mr-stat-card">
                  <div className="mr-stat-icon" style={{ backgroundColor: s.iconBg, color: s.iconColor }}>
                    {s.icon}
                  </div>
                  <div className="mr-stat-content">
                    <h3>{s.value}</h3>
                    <p>{s.label}</p>
                  </div>
                </div>
              </Col>
            ))}
          </Row>
        </div>

        {/* ════════════════════════════════
            ✅ TABLE — MyEquipment style
        ════════════════════════════════ */}
        <div className="mr-table-section">

          <div className="mr-section-header">
            <h2 className="mr-section-title">Rental Records</h2>
          </div>

          <div className="mr-table-wrapper">
            <table className="mr-table">
              <thead>
                <tr>
                  <th>RENTER NAME</th>
                  <th>EQUIPMENT</th>
                  <th>OWNER/SHOP</th>
                  <th>LOCATION</th>
                  <th>DURATION</th>
                  <th>TOTAL PRICE</th>
                  <th>STATUS</th>
                  <th className="mr-col-action">ACTIONS</th>
                </tr>
              </thead>
              <tbody>
                {currentRentals.length > 0 ? currentRentals.map(r => (
                  <tr key={r.id}>
                    <td className="mr-renter-name">{r.renterName}</td>
                    <td>{r.equipment}</td>
                    <td>{r.owner}</td>
                    <td>{r.location}</td>
                    <td>{fmtDuration(r.startDate, r.endDate)}</td>
                    <td><span className="mr-price">Rs {r.totalCost.toLocaleString()}</span></td>
                    <td>
                      <span className={`mr-status-badge ${getStatusClass(r.status)}`}>
                        <span className="mr-badge-dot"></span>
                        {r.status}
                      </span>
                    </td>
                    <td className="mr-col-action">
                      <div className="mr-dropdown-wrapper">
                        <button className="mr-dots-btn" onClick={() => setActiveDropdown(activeDropdown === r.id ? null : r.id)}>
                          <FaEllipsisV size={15} />
                        </button>
                        {activeDropdown === r.id && (
                          <div className="mr-dropdown-menu">
                            <button className="mr-dropdown-item" onClick={() => openDispute(r)}>
                              <FaExclamationCircle className="mr-item-dispute" /> Dispute
                            </button>
                            <div className="mr-dropdown-divider" />
                            <button className="mr-dropdown-item" onClick={() => openDetails(r)}>
                              <FaEye className="mr-item-view" /> View Details
                            </button>
                            {r.status === "Completed" && (
                              <>
                                <div className="mr-dropdown-divider" />
                                <button className="mr-dropdown-item" onClick={() => openReview(r)}>
                                  <FaStar className="mr-item-review" /> Write a Review
                                </button>
                              </>
                            )}
                          </div>
                        )}
                      </div>
                    </td>
                  </tr>
                )) : (
                  <tr><td colSpan="8" className="mr-empty-row">No rentals found</td></tr>
                )}
              </tbody>
            </table>
          </div>

          {/* Pagination */}
          <AppPagination
  currentPage={currentPage}
  totalPages={totalPages}
  totalItems={rentals.length}
  itemsPerPage={rentalsPerPage}
  onPageChange={(page) => setCurrentPage(page)}
/>
        </div>

        {/* ════════════════════════════════
            ✅ VIEW DETAILS MODAL — PayoutsManagement style
        ════════════════════════════════ */}
        {showDetailsModal && selectedRental && (
          <div className="mr-modal-overlay" onClick={() => { setShowDetailsModal(false); setIsEditMode(false); }}>
            <div className="mr-modal-box" onClick={e => e.stopPropagation()}>

              {/* Black Header */}
              <div className="mr-modal-header-dark">
                <div>
                  <h5 className="mr-modal-header-title">
                    {isEditMode ? 'Edit Rental Details' : 'Rental Details'}
                  </h5>
                  <span className="mr-modal-header-sub">Full breakdown of this rental</span>
                </div>
                <button className="mr-modal-close-circle" onClick={() => { setShowDetailsModal(false); setIsEditMode(false); }}>
                  <FiX />
                </button>
              </div>

              {/* Body */}
              <div className="mr-modal-body">

                {/* Status Bar */}
                <div className="mr-modal-status-bar">
                  <div className="mr-sb-left">
                    <FiHash size={15} color="#FDB714" />
                    <span className="mr-sb-id">RNT-{String(selectedRental.id).padStart(3,'0')}</span>
                    <span className={`mr-modal-badge ${getModalStatusClass(selectedRental.status)}`}>
                      <span className="mr-modal-badge-dot"></span>
                      {selectedRental.status}
                    </span>
                  </div>
                  <div className="mr-sb-date">
                    <FiCalendar size={13} />
                    {selectedRental.startDate} → {selectedRental.endDate}
                  </div>
                </div>

                {/* Renter Strip */}
                <p className="mr-section-label"><FiUser size={14} /> Renter Information</p>
                <div className="mr-modal-renter-strip">
                  <div className="mr-renter-avatar">
                    {editedRental.renterName.charAt(0).toUpperCase()}
                  </div>
                  <div className="mr-renter-info">
                    {isEditMode ? (
                      <input className="mr-edit-input" value={editedRental.renterName} onChange={e => handleEditChange('renterName', e.target.value)} />
                    ) : (
                      <div className="mr-renter-name">{editedRental.renterName}</div>
                    )}
                    <div className="mr-renter-owner">Owner: {editedRental.owner}</div>
                  </div>
                  <span className={`mr-modal-badge ${getModalStatusClass(editedRental.status)}`}>
                    <span className="mr-modal-badge-dot"></span>
                    {editedRental.status}
                  </span>
                </div>

                {/* Details Grid */}
                <p className="mr-section-label"><FiHash size={14} /> Rental Details</p>
                <div className="mr-info-grid">
                  <div className="mr-info-item">
                    <label>Equipment</label>
                    {isEditMode
                      ? <input className="mr-edit-input" value={editedRental.equipment} onChange={e => handleEditChange('equipment', e.target.value)} />
                      : <span>{editedRental.equipment}</span>}
                  </div>
                  <div className="mr-info-item">
                    <label>Owner</label>
                    {isEditMode
                      ? <input className="mr-edit-input" value={editedRental.owner} onChange={e => handleEditChange('owner', e.target.value)} />
                      : <span>{editedRental.owner}</span>}
                  </div>
                  <div className="mr-info-item">
                    <label>Start Date</label>
                    {isEditMode
                      ? <input type="date" className="mr-edit-input" value={editedRental.startDate} onChange={e => handleEditChange('startDate', e.target.value)} />
                      : <span>{new Date(editedRental.startDate).toLocaleDateString()}</span>}
                  </div>
                  <div className="mr-info-item">
                    <label>End Date</label>
                    {isEditMode
                      ? <input type="date" className="mr-edit-input" value={editedRental.endDate} onChange={e => handleEditChange('endDate', e.target.value)} />
                      : <span>{new Date(editedRental.endDate).toLocaleDateString()}</span>}
                  </div>
                </div>

                {/* Location */}
                <p className="mr-section-label"><FiMapPin size={14} /> Location</p>
                <div className="mr-location-box">
                  <FiMapPin size={16} color="#FDB714" />
                  {isEditMode
                    ? <input className="mr-edit-input" style={{ flex: 1 }} value={editedRental.location} onChange={e => handleEditChange('location', e.target.value)} />
                    : <span>{editedRental.location}</span>}
                </div>

                {/* Financials */}
                <p className="mr-section-label"><FiDollarSign size={14} /> Financial Breakdown</p>
                <div className="mr-financials-box">
                  <div className="mr-fin-row">
                    <span>Duration</span>
                    <span>{fmtDuration(editedRental.startDate, editedRental.endDate)}</span>
                  </div>
                  <div className="mr-fin-row mr-fin-total">
                    <span>Total Cost</span>
                    <span>Rs {editedRental.totalCost.toLocaleString()}</span>
                  </div>
                </div>

                {/* Status (edit only) */}
                {isEditMode && (
                  <div className="mr-field-group" style={{ marginTop: '16px' }}>
                    <label className="mr-field-label">Status</label>
                    <select className="mr-edit-input" value={editedRental.status} onChange={e => handleEditChange('status', e.target.value)}>
                      <option value="Active">Active</option>
                      <option value="Completed">Completed</option>
                      <option value="Pending">Pending</option>
                    </select>
                  </div>
                )}

              </div>

              {/* Footer */}
              <div className="mr-modal-footer-list">
                {isEditMode ? (
                  <>
                    <button className="mr-mf-btn mr-mf-save" onClick={handleSaveEdit}>
                      <FiSave size={15} /> Save Changes
                    </button>
                    <button className="mr-mf-btn mr-mf-close" onClick={() => { setIsEditMode(false); setEditedRental({...selectedRental}); }}>
                      <FiX size={15} /> Cancel
                    </button>
                  </>
                ) : (
                  <>
                    <button className="mr-mf-btn mr-mf-edit" onClick={() => setIsEditMode(true)}>
                      <FiEdit size={15} /> Edit Details
                    </button>
                    <button className="mr-mf-btn mr-mf-close" onClick={() => setShowDetailsModal(false)}>
                      <FiX size={15} /> Close
                    </button>
                  </>
                )}
              </div>
            </div>
          </div>
        )}

        {/* ════════════════════════════════
            ✅ DISPUTE MODAL — PayoutsManagement style
        ════════════════════════════════ */}
        {showDisputeModal && (
          <div className="mr-modal-overlay" onClick={() => setShowDisputeModal(false)}>
            <div className="mr-modal-box mr-modal-xl" onClick={e => e.stopPropagation()}>

              <div className="mr-modal-header-dark">
                <div>
                  <h5 className="mr-modal-header-title">Rental Dispute Management</h5>
                  <span className="mr-modal-header-sub">Submit a dispute ticket for this rental</span>
                </div>
                <button className="mr-modal-close-circle" onClick={() => setShowDisputeModal(false)}><FiX /></button>
              </div>

              <div className="mr-modal-body">
                <div className="mr-dispute-body">

                  {/* Left — Form */}
                  <div className="mr-dispute-left">
                    <p className="mr-section-label"><FiAlertCircle size={14} /> Create Dispute Ticket</p>
                    <Form onSubmit={handleDisputeSubmit}>
                      <div className="mr-field-group mb-3">
                        <label className="mr-field-label">Raised By</label>
                        <input className="mr-edit-input" name="raisedBy" defaultValue={selectedRental?.renterName || "John Smith"} readOnly />
                      </div>
                      <div className="mr-field-group mb-3">
                        <label className="mr-field-label">Against</label>
                        <input className="mr-edit-input" name="against" defaultValue={selectedRental?.owner || "Farm Owner"} readOnly />
                      </div>
                      <div className="mr-field-group mb-3">
                        <label className="mr-field-label">Equipment</label>
                        <input className="mr-edit-input" name="equipment" value={selectedRental?.equipment || "N/A"} readOnly />
                      </div>
                      <div className="mr-field-group mb-3">
                        <label className="mr-field-label">Category</label>
                        <select className="mr-edit-input" name="category" required>
                          <option value="">Select Category</option>
                          <option value="Equipment Damage">Equipment Damage</option>
                          <option value="Service Delay">Service Delay</option>
                          <option value="Payment Issue">Payment Issue</option>
                          <option value="Quality Issue">Quality Issue</option>
                          <option value="Other">Other</option>
                        </select>
                      </div>
                      <div className="mr-field-group mb-3">
                        <label className="mr-field-label">Date</label>
                        <input type="date" className="mr-edit-input" name="date" defaultValue={new Date().toISOString().split('T')[0]} required />
                      </div>
                      <div className="mr-field-group mb-3">
                        <label className="mr-field-label">Description</label>
                        <textarea className="mr-edit-input mr-textarea" name="description" rows={3} placeholder="Describe the issue..." required />
                      </div>
                      <button type="submit" className="mr-submit-btn">Submit Dispute Ticket</button>
                    </Form>
                  </div>

                  {/* Right — Tickets & Chat */}
                  <div className="mr-dispute-right">
                    <p className="mr-section-label">Dispute Tickets</p>
                    {disputeTickets.length === 0 ? (
                      <div className="mr-empty-state">No dispute tickets yet. Submit a ticket to get started.</div>
                    ) : (
                      <div className="mr-tickets-list">
                        {disputeTickets.map(ticket => (
                          <div
                            key={ticket.id}
                            className={`mr-ticket-card ${selectedTicket?.id === ticket.id ? 'selected' : ''}`}
                            onClick={() => setSelectedTicket(ticket)}
                          >
                            <div className="mr-ticket-header">
                              <strong>#{ticket.id}</strong>
                              <span className={`mr-ticket-badge ${ticket.status === 'Open' ? 'open' : 'closed'}`}>{ticket.status}</span>
                            </div>
                            <div className="mr-ticket-body">
                              <div><strong>Equipment:</strong> {ticket.equipment}</div>
                              <div><strong>Category:</strong> {ticket.category}</div>
                              <div className="mr-ticket-date">{ticket.createdAt}</div>
                            </div>
                          </div>
                        ))}
                      </div>
                    )}

                    {/* Chat */}
                    {selectedTicket && (
                      <div className="mr-chat-container">
                        <div className="mr-chat-header">Chat — Ticket #{selectedTicket.id}</div>
                        <div className="mr-chat-messages">
                          {!chatMessages[selectedTicket.id]?.length ? (
                            <div className="mr-chat-empty">No messages yet. Start the conversation!</div>
                          ) : chatMessages[selectedTicket.id].map(msg => (
                            <div key={msg.id} className={`mr-chat-msg ${msg.sender === 'User' ? 'sent' : 'received'}`}>
                              <div className={`mr-msg-bubble ${msg.sender === 'User' ? 'sent' : 'received'}`}>
                                <div className="mr-msg-sender">{msg.sender}</div>
                                <div className="mr-msg-text">{msg.message}</div>
                                <div className="mr-msg-time">{msg.timestamp}</div>
                              </div>
                            </div>
                          ))}
                        </div>
                        <div className="mr-chat-input-area">
                          <input
                            type="text" className="mr-chat-input"
                            value={currentMessage}
                            onChange={e => setCurrentMessage(e.target.value)}
                            onKeyPress={e => e.key === 'Enter' && handleSendMessage()}
                            placeholder="Type your message..."
                          />
                          <button className="mr-chat-send-btn" onClick={handleSendMessage}>Send</button>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* ════════════════════════════════
            ✅ WRITE REVIEW MODAL — PayoutsManagement style
        ════════════════════════════════ */}
        {showReviewModal && selectedRental && (
          <div className="mr-modal-overlay" onClick={() => setShowReviewModal(false)}>
            <div className="mr-modal-box" onClick={e => e.stopPropagation()}>

              <div className="mr-modal-header-dark">
                <div>
                  <h5 className="mr-modal-header-title">Write a Review</h5>
                  <span className="mr-modal-header-sub">Share your experience with this equipment</span>
                </div>
                <button className="mr-modal-close-circle" onClick={() => setShowReviewModal(false)}><FiX /></button>
              </div>

              <div className="mr-modal-body">
                <div className="mr-field-group mb-3">
                  <label className="mr-field-label">Equipment</label>
                  <input className="mr-edit-input" value={selectedRental.equipment} readOnly />
                </div>

                <p className="mr-section-label"><FaStar size={14} color="#FDB714" /> Your Rating</p>
                <div className="mr-star-rating">
                  {[1,2,3,4,5].map(star => (
                    <span
                      key={star}
                      className={`mr-star ${rating >= star ? 'filled' : ''}`}
                      onClick={() => setRating(star)}
                    >★</span>
                  ))}
                  <span className="mr-rating-text">{rating > 0 ? `${rating} out of 5` : 'Select rating'}</span>
                </div>

                <div className="mr-field-group mt-3">
                  <label className="mr-field-label">Your Review</label>
                  <textarea
                    className="mr-edit-input mr-textarea"
                    rows={4}
                    placeholder="Share your experience with this equipment..."
                    value={reviewText}
                    onChange={e => setReviewText(e.target.value)}
                    required
                  />
                </div>
              </div>

              <div className="mr-modal-footer-list">
                <button className="mr-mf-btn mr-mf-save" onClick={handleReviewSubmit}>
                  <FiCheckCircle size={15} /> Submit Review
                </button>
                <button className="mr-mf-btn mr-mf-close" onClick={() => setShowReviewModal(false)}>
                  <FiX size={15} /> Cancel
                </button>
              </div>

            </div>
          </div>
        )}

      </div>
    </UserMasterLayout>
  );
};

export default MyRentals;